import React, { useContext, useState } from 'react'
import { AppContext } from '../../../App'

export default function ResinousApplication({ value:name, categoryImage:img }) {
   const {
      setCurrentStep,
      setLinkGoBackTarget,
      setProductTypeSteps,
      setAppHeader,
      productOptionsSelected,
      setProductOptionsSelected,
      stepsCompleted,
      setStepsCompleted
   } = useContext(AppContext)

   const application = name.toLowerCase()

   const [resinousApplicationSelected, toggleResinousApplicationSelected] = useState({ selected: false })

   // Determine next step according to { application }.
   const applicationSwitch = (n) => {
      return ({ step: "resinousSystemSelection" })
   }

   const setStepTotal = () => {
      // Determine number of steps per resinous application selected
      switch(application) {
         // Add 1 for "Application Selection"
         case "floor": return 4
         case "wall": return 4
         case "cove": return 4
         case "adhesives": return 3
         case "grout": return 3
         case "underlayment": return 3
         default: alert("Product Type or application not found. Cannot setStepTotal.")
      }
   }

   const handleSelectResinousApplication = () => {
      // Toggle the "selected" state of selected resinous application.
      toggleResinousApplicationSelected(
      // Set resinousApplicationSelected.selected to inverse.
         resinousApplicationSelected.selected ? { selected: false } : { selected: true } 
      )
      // Set the current step to the next step.
      setCurrentStep(applicationSwitch(application.toL))
      // Update the state of "link", for linkGoBack
      setLinkGoBackTarget({ link: "resinousApplicationSelection" })
      // Set number of steps in the quote depending on application selected.
      setProductTypeSteps(setStepTotal(application))
      // Set the appHeader for Step state
      setAppHeader("Step X")
      // Set the appHeader for Step state
      setAppHeader("Step 2 of " + setStepTotal())
      // Add the selected resinous application to state of App
      productOptionsSelected.productOptions.push(name)
      setProductOptionsSelected({ productOptions: productOptionsSelected.productOptions })

      stepsCompleted.push("Select Resinous Application")
      setStepsCompleted(stepsCompleted)
   }

   return (
      <div className="list-item" key={ application } onClick={ handleSelectResinousApplication } >
         <div className="row p-1">
               <div className="col-xs-6 col-sm-4 vcenter">
                  <figure>
                     <img src={ "https://cdn.laticrete.com/" + img || "http://via.placeholder.com/737x737" }  alt={ " " } className="img-responsive" />
                  </figure>
               </div>
               <div className="col-xs-6 col-sm-8 vcenter">
                  <h4>{name}</h4>
               </div>
         </div>
      </div>
   )
}


// WEBPACK FOOTER //
// ./src/components/productTypes/resinous/ResinousApplication.js